<template lang="html">
  <div class="card" :style="selfStyle">
    <div class="card-body">
      <div class="card-header">
        温馨通道
      </div>
      <ul class="card-content">
        <li class="card-content-item" :key="item.id" v-for="item in datas">
          <a :href="item.url" >{{item.label}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'selfStyle'
  ],
  data () {
    return {
      datas: [
        {
          id: 1,
          label: '复星OA系统',
          url: 'https://oa.fosun.com/'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  box-sizing: border-box;
  padding: 0 7.5px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 2px;
  .card-body {
    background-color: #fff;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
    .card-content {
      padding: 10px 15px;
      .card-content-item {
        line-height: 26px;
        list-style-position: inside;
        list-style-type: disc;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        list-style: none;
        a {
          color: #01AAED;
          text-decoration: none;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
